import {registerReducer} from 'js/studios/shared/redux/utils'

function user(state={}, action){
  switch (action.type){
    case "USER_LOGIN":
      return action.user
    default:
      return state
  }
}

registerReducer(user, 'user', true)
